import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ListItemsEffects } from './list-items.effects';
import { listItemsReducer } from './list-items.reducer';
import { STATE_LIST_ITEMS, getInitialListItemsState } from './list-items.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ListItemsEffects]),
    StoreModule.forFeature(STATE_LIST_ITEMS, listItemsReducer, {
      initialState: getInitialListItemsState,
    }),
  ],
})
export class ListItemsModule {}
